export default "/img/NO.20502f84c9d3e32c0ed544c0248e84a8.png";